<template>
  <billing-invoice :invoiceid="invoiceid" />
</template>

<script>
import BillingInvoice from '@/components/Billing/BillingInvoice'

export default {
  name: 'BillingInvoiceView',
  props: {
    invoiceid: {
      type: String,
      required: true
    }
  },
  components: {
    BillingInvoice
  }
}
</script>
